// extracted by mini-css-extract-plugin
module.exports = {"ContentSection":"ContentSection_ContentSection__pByU6"};